import { formatDate } from '@angular/common';
import { DEFAULT_LOCALE_ID } from '@configs/constants';
import { Block } from 'notiflix';
import { BehaviorSubject, Observable, defer, finalize } from 'rxjs';

export function getNotifyBody(title: string, message: string) {
  return `
    <div class="d-flex flex-column">
      <div class="fw-bold">${title}</div>
      <div class="text-gray-500">${message}</div>
      <div class="text-gray-500 fs-8">${formatDate(Date.now(), 'medium', DEFAULT_LOCALE_ID)}</div>
    </div>
  `;
}

export function withLoading<T>(loading: BehaviorSubject<boolean>) {
  return (source: Observable<T>) => {
    return defer(() => {
      loading.next(true);

      return source.pipe(finalize(() => loading.next(false)));
    });
  };
}

export function removeNullable<T extends Record<string, unknown>>(arg: T): T {
  return Object.fromEntries(
    Object.entries(arg).filter(([_, value]) =>
      typeof value === 'boolean'
        ? true
        : typeof value === 'string'
          ? value.trim().length
          : Array.isArray(value)
            ? value.length
            : value
    )
  ) as T;
}

export function setEmptyToNull<T extends Record<string, unknown>>(arg: T): T {
  return Object.fromEntries(
    Object.entries(arg).map(([key, value]) => [
      key,
      (typeof value !== 'string' && !Array.isArray(value)) ||
        (typeof value === 'string' && value.trim().length) ||
        (Array.isArray(value) && value.length)
        ? value
        : null
    ])
  ) as T;
}

export function showLoading(element?: HTMLElement | null, opts?: Notiflix.IBlockOptions & { message?: string }) {
  const isButton = element instanceof HTMLButtonElement;
  element ??= document.body;

  if (isButton) element?.toggleAttribute('disabled');

  Block.circle([element], opts?.message, opts);

  return {
    removeLoading: () => {
      if (isButton) element?.toggleAttribute('disabled');

      Block.remove([element]);
    }
  };
}

export function formatCedulaString(value: string): string {
  if (!value) return '';
  const numericValue = value.replace(/\D/g, '');
  let formattedValue = '';
  if (numericValue.length > 0) {
    formattedValue += numericValue.substring(0, 3);
  }
  if (numericValue.length > 3) {
    formattedValue += '-' + numericValue.substring(3, 10);
  }
  if (numericValue.length > 10) {
    formattedValue += '-' + numericValue.substring(10, 11);
  }
  return formattedValue;
}
